import { ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Theme keys from `globals.css` that tailwind-merge can't infer from their names.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      'font-weight': ['regular'],
      spacing: ['sidebar'],
    },
    classGroups: {
      z: [{ z: ['table-bar', 'selection-bar', 'dialog', 'dropdown'] }],
    },
  },
});

function classNames(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export default classNames;
